import IframeResizer, { IframeResizerProps } from 'iframe-resizer-react';

export const IFrame = ({ src, ...props }: IframeResizerProps) => {
  if (!src?.startsWith('http')) {
    return null;
  }

  return <IframeResizer checkOrigin={false} allowFullScreen={true} src={src} {...props} />;
};
